module.exports = __webpack_public_path__ + "static/project2.e96790f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project2.png
// module id = 445
// module chunks = 111930841657428